import { isRuleSimulationResponse, } from '@urbanik/api-contracts';
export class RuleSimulationApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'RuleSimulationApiError';
    }
}
export async function simulateRules(base, input) {
    let response;
    try {
        response = await fetch(`${base.replace(/\/$/, '')}/identity/governance/rule-simulations`, {
            method: 'POST',
            credentials: 'include',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(input),
        });
    }
    catch {
        throw new RuleSimulationApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const body = await response.json();
    if (!response.ok) {
        const message = typeof body === 'object' &&
            body !== null &&
            typeof body.message === 'string'
            ? body.message
            : 'No pudimos completar la simulación.';
        throw new RuleSimulationApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 404
                    ? 'not-found'
                    : response.status === 400
                        ? 'validation'
                        : 'unavailable', message);
    }
    if (!isRuleSimulationResponse(body))
        throw new RuleSimulationApiError('invalid', 'El desglose recibido no es válido.');
    return body;
}
